<template>
  <div>
    <slot v-bind:height="height" v-bind:gap="gap" v-bind:width="width"></slot>
  </div>
</template>

<script>
import { O3DG2, getScreen } from '../Reusable/O3DG2'
import { PlaneBufferGeometry, Object3D, Vector3, DoubleSide, Mesh } from 'three'
import { ImageMaterial } from '../GLContent/FullerImage/ImageMaterial'
export default {
  mixins: [O3DG2],
  data () {
    return {
      vm: this,
      ready: false,
      width: 0,
      height: 0,
      gap: 0,
      tmo3: new Object3D(),
      tmo3btm: new Vector3(),
      tm3: new Vector3(),
      screen: false
    }
  },
  mounted () {
    let doLayout = ({ mesh, config }) => {
      let aspect = config.width / config.height
      let aspectR = config.height / config.width

      this.onResize(() => {
        this.screen = getScreen({ camera: this.ctx.camera, depth: this.tm3.setFromMatrixPosition(this.o3d.matrixWorld).z })
        let { width, height } = this.screen
        if (height < width) {
          let halfScreenHeight = height * 0.5
          let halfImageHeight = height * 0.5
          let gap = halfScreenHeight - halfImageHeight
          mesh.geometry = new PlaneBufferGeometry(height * aspect, height, 62, 2)
          mesh.geometry.translate(0, gap, 0)
          this.gap = gap
          this.height = height * -1
          this.width = height * aspect
        } else {
          let halfScreenHeight = height * 0.5
          let halfImageHeight = width * aspectR * 0.5
          let gap = halfScreenHeight - halfImageHeight
          mesh.geometry = new PlaneBufferGeometry(width, width * aspectR, 62, 2)
          mesh.geometry.translate(0, gap, 0)
          this.gap = gap
          this.height = width * aspectR * -1
          this.width = width
        }

        if (this.ctx.relayout) {
          this.ctx.relayout()
        }
      })
    }
    let mat = new ImageMaterial({ side: DoubleSide })
    let mesh = new Mesh(undefined, mat)
    this.o3d.add(mesh)
    this.onLoop(() => {
      mat.time = window.performance.now() * 0.001
      mat.velocity = this.ctx.vs.diff
    })
    let config = false
    this.$on('config', (v) => {
      config = v
      mat.image = v.map
      doLayout({ mesh, config })
    })
  }
}
</script>

<style>

</style>
